export * as absence from './absence'
export * as academicStaffing from './academic-staffing'
export * as adaptive from './adaptive'
export * as bankingAndSetttlement from './banking-and-setttlement'
export * as benefits from './benefits'
export * as businessAssets from './business-assets'
export * as compensation from './compensation'
export * as coreFinancialsFdm from './core-financials-fdm'
export * as crossFunctional from './cross-functional'
export * as customerAccounts from './customer-accounts'
export * as data from './data'
export * as effortReporting from './effort-reporting'
export * as financialAccounting from './financial-accounting'
export * as general from './general'
export * as grants from './grants'
export * as hcmCore from './hcm-core'
export * as integrations from './integrations'
export * as inventoryManagement from './inventory-management'
export * as learning from './learning'
export * as payroll from './payroll'
export * as payrollAccounting from './payroll-accounting'
export * as procurement from './procurement'
export * as recruiting from './recruiting'
export * as reporting from './reporting'
export * as supplierAccounts from './supplier-accounts'
export * as talent from './talent'
export * as timeTracking from './time-tracking'
